import axios from "axios";

const instance = axios.create({
    baseURL: 'https://burger-builder-528f3.firebaseio.com/'
});

export default instance;
